<script>
	import { fade, slide, fly } from 'svelte/transition';
	export let alertMessage, textalert, color;
	$: if (alertMessage) {
		setTimeout(() => {
			alertMessage = false;
		}, 2000);
	}
</script>

<div class="" />
<div
	transition:fly={{
		y: -200,
		duration: 500
	}}
	class="p-4 fixed top-1 right-10 w-max min-w-fit z-50 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
>
	<div class="flex">
		<div class="flex-shrink-0">
			<!-- Heroicon name: mini/check-circle -->
		</div>
		<div class="ml-3">
			<p class="text-sm font-medium text-red-300">{textalert}</p>
		</div>
		<div class="ml-auto pl-3" />
	</div>
</div>
